const questions = [
    {
        question: 'What kind of loan do you need?',
        type: 'select',
        options: [
            {
                label: 'What kind of loan do you need?',
                value: 'select'
            },
            {
                label: 'Debt Consolidation',
                value: 'DEBT_CONSOLIDATION'
            },
            {
                label: 'Credit Card Refinancing',
                value: 'CREDIT_CARD_REFINANCING'
            },
            {
                label: 'Home Improvement',
                value: 'CONSUMER_HOME_IMPROVEMENT'
            },
            {
                label: 'Major Purchases',
                value: 'MAJOR_PURCHASE'
            },
            {
                label: 'Business',
                value: 'BUSINESS'
            },
            {
                label: 'Vacation',
                value: 'VACATION'
            },
            {
                label: 'Moving and Relocation',
                value: 'MOVING_AND_RELOCATION'
            },
            {
                label: 'Medical Expenses',
                value: 'MEDICAL_EXPENSES'
            },
            {
                label: 'Taxes',
                value: 'TAXES'
            },
            {
                label: 'Other',
                value: 'CONSUMER_OTHER'
            }
        ],
        name: 'loan[purpose]',
        id: 'request_type',
        register: 'loanType',
        classNames: 'select-input col-11 col-md-8 my-2',
        top: 0,
        slide: 1,
        answer: null,
        required: true,
        save: false
    },
    {
        question: 'How much do you need?',
        type: 'currency',
        inputMode: 'numeric',
        name: 'loan[request]',
        id: 'request_amount',
        register: 'loanAmount',
        classNames: 'text-input col-11 col-md-8 my-2',
        top: 2.67,
        slide: 1,
        answer: null,
        required: true,
        save: false,
        rules: {
            maxDigits: 6,
            min: 1000,
            max: 100000
        },
        error: 'The amount you request must be between $1,000 and $100,000'
    },

    {
        question: 'Your approximate credit rating?',
        type: 'select',
        options: [
            {
                label: 'What’s your approximate credit rating?',
                value: 'select'
            },
            {
                label: 'Excellent',
                value: 'excellent'
            },
            {
                label: 'Good',
                value: 'good'
            },
            {
                label: 'Fair',
                value: 'fair'
            },
            {
                label: 'Poor',
                value: 'poor'
            },
            {
                label: 'Limited',
                value: 'limited'
            },
            {
                label: 'Unknown',
                value: 'unknown'
            }
        ],
        name: 'loan[credit_score]',
        id: 'credit_rating',
        register: 'estCreditRange',
        classNames: 'select-input col-11 col-md-8 my-2',
        top: 5.33,
        slide: 1,
        answer: null,
        required: true,
        save: false
    },
    {
        question: 'First Name',
        type: 'text',
        inputMode: 'text',
        name: 'loan[first_name]',
        id: 'loan_first_name',
        register: 'firstName',
        classNames: 'text-input col-11 col-md-5 my-2 float-left',
        top: 25,
        slide: 2,
        answer: null,
        required: true,
        save: false
    },
    {
        question: 'Last Name',
        type: 'text',
        inputMode: 'text',
        name: 'loan[last_name]',
        id: 'loan_last_name',
        register: 'lastName',
        classNames: 'text-input col-11 col-md-5 my-2 float-left ml-md-3',
        top: 27,
        slide: 2,
        answer: null,
        required: true,
        save: false
    },
    {
        question: 'Street Address',
        type: 'text',
        inputMode: 'text',
        name: 'address[street]',
        id: 'address_street',
        register: 'streetAddress',
        classNames: 'text-input col-11 col-md-5 my-2 float-left',
        top: 29,
        slide: 2,
        answer: null,
        required: true,
        save: true
    },
    // {
    //     question: 'Street Address Cont.',
    //     type: 'text',
    //     name: 'address[line_1]',
    //     id: 'address_street_1',
    //     register: 'streetAddress2',
    //     classNames: 'text-input col-10 col-md-5 my-2 float-left ml-md-3',
    //     top: 16,
    //     slide: 2,
    //     answer: null,
    //     required: false
    // },
    {
        question: 'City',
        type: 'text',
        inputMode: 'text',
        name: 'address[city]',
        id: 'address_city',
        register: 'city',
        classNames: 'text-input col-11 col-md-5 my-2 float-left ml-md-3',
        top: 31,
        slide: 2,
        answer: null,
        required: true,
        save: true
    },
    {
        question: 'State',
        type: 'select',
        options: [
            {
                label: 'State',
                value: 'XX'
            },
            {
                label: 'Alabama',
                value: 'AL'
            },
            {
                label: 'Alaska',
                value: 'AK'
            },
            {
                label: 'American Samoa',
                value: 'AS'
            },
            {
                label: 'Arizona',
                value: 'AZ'
            },
            {
                label: 'Arkansas',
                value: 'AR'
            },
            {
                label: 'California',
                value: 'CA'
            },
            {
                label: 'Colorado',
                value: 'CO'
            },
            {
                label: 'Connecticut',
                value: 'CT'
            },
            {
                label: 'Delaware',
                value: 'DE'
            },
            {
                label: 'District Of Columbia',
                value: 'DC'
            },
            {
                label: 'Federated States Of Micronesia',
                value: 'FM'
            },
            {
                label: 'Florida',
                value: 'FL'
            },
            {
                label: 'Georgia',
                value: 'GA'
            },
            {
                label: 'Guam',
                value: 'GU'
            },
            {
                label: 'Hawaii',
                value: 'HI'
            },
            {
                label: 'Idaho',
                value: 'ID'
            },
            {
                label: 'Illinois',
                value: 'IL'
            },
            {
                label: 'Indiana',
                value: 'IN'
            },
            {
                label: 'Iowa',
                value: 'IA'
            },
            {
                label: 'Kansas',
                value: 'KS'
            },
            {
                label: 'Kentucky',
                value: 'KY'
            },
            {
                label: 'Louisiana',
                value: 'LA'
            },
            {
                label: 'Maine',
                value: 'ME'
            },
            {
                label: 'Marshall Islands',
                value: 'MH'
            },
            {
                label: 'Maryland',
                value: 'MD'
            },
            {
                label: 'Massachusetts',
                value: 'MA'
            },
            {
                label: 'Michigan',
                value: 'MI'
            },
            {
                label: 'Minnesota',
                value: 'MN'
            },
            {
                label: 'Mississippi',
                value: 'MS'
            },
            {
                label: 'Missouri',
                value: 'MO'
            },
            {
                label: 'Montana',
                value: 'MT'
            },
            {
                label: 'Nebraska',
                value: 'NE'
            },
            {
                label: 'Nevada',
                value: 'NV'
            },
            {
                label: 'New Hampshire',
                value: 'NH'
            },
            {
                label: 'New Jersey',
                value: 'NJ'
            },
            {
                label: 'New Mexico',
                value: 'NM'
            },
            {
                label: 'New York',
                value: 'NY'
            },
            {
                label: 'North Carolina',
                value: 'NC'
            },
            {
                label: 'North Dakota',
                value: 'ND'
            },
            {
                label: 'Northern Mariana Islands',
                value: 'MP'
            },
            {
                label: 'Ohio',
                value: 'OH'
            },
            {
                label: 'Oklahoma',
                value: 'OK'
            },
            {
                label: 'Oregon',
                value: 'OR'
            },
            {
                label: 'Palau',
                value: 'PW'
            },
            {
                label: 'Pennsylvania',
                value: 'PA'
            },
            {
                label: 'Puerto Rico',
                value: 'PR'
            },
            {
                label: 'Rhode Island',
                value: 'RI'
            },
            {
                label: 'South Carolina',
                value: 'SC'
            },
            {
                label: 'South Dakota',
                value: 'SD'
            },
            {
                label: 'Tennessee',
                value: 'TN'
            },
            {
                label: 'Texas',
                value: 'TX'
            },
            {
                label: 'Utah',
                value: 'UT'
            },
            {
                label: 'Vermont',
                value: 'VT'
            },
            {
                label: 'Virgin Islands',
                value: 'VI'
            },
            {
                label: 'Virginia',
                value: 'VA'
            },
            {
                label: 'Washington',
                value: 'WA'
            },
            {
                label: 'West Virginia',
                value: 'WV'
            },
            {
                label: 'Wisconsin',
                value: 'WI'
            },
            {
                label: 'Wyoming',
                value: 'WY'
            }
        ],
        name: 'address[state]',
        id: 'address_state',
        register: 'state',
        classNames: 'text-input col-md-3 col-5 my-2 mr-md-2',
        top: 33,
        slide: 2,
        answer: null,
        save: true
    },
    {
        question: 'Postal Code',
        type: 'text',
        inputMode: 'numeric',
        name: 'address[zip_code]',
        id: 'address_zip_code',
        register: 'zip',
        classNames: 'text-input col-md-3 col-6 my-2 ml-1 ml-md-0',
        top: 35,
        slide: 2,
        answer: null,
        required: true,
        save: true,
        rules: {
            maxDigits: 5
        },
    },
    {
        question: 'What’s your email address?',
        type: 'text',
        inputMode: 'text',
        name: 'loan[email]',
        id: 'loan_email',
        register: 'email',
        classNames: 'text-input col-11 col-md-5 my-2 float-left',
        top: 50,
        slide: 3,
        answer: null,
        required: true,
        save: true
    },
    {
        question: 'Confirm Email Address',
        type: 'text',
        inputMode: 'text',
        name: 'loan[confirm_email]',
        id: 'loan_confirm_email',
        register: 'email_confirmation',
        classNames: 'text-input col-11 col-md-5 my-2 float-left ml-md-3',
        top: 53,
        slide: 3,
        answer: null,
        required: true,
        save: true,
        rules: {
            confirm: 'email'
        },
        error: 'The emails do not match.'

    },

    {
        question: 'Date of Birth (mm/dd/yyyy)',
        type: 'date',
        inputMode: 'numeric',
        name: 'loan[dob]',
        id: 'loan_dob',
        register: 'birthDate',
        classNames: 'text-input col-11 col-md-5 my-2 float-left',
        top: 56,
        slide: 3,
        answer: null,
        required: true,
        save: true
    },
    {
        question: 'Phone',
        type: 'phone',
        inputMode: 'numeric',
        name: 'loan[mobile]',
        id: 'loan_mobile',
        register: 'phone',
        classNames: 'text-input col-11 col-md-5 my-2 float-left ml-md-3',
        top: 59,
        slide: 3,
        answer: null,
        required: true,
        save: true
    },
    {
        question: 'Employment Status',
        type: 'select',
        options: [
            {
                label: 'Employment Status',
                value: 'select'
            },
            {
                label: 'Employed',
                value: 'employed'
            },
            {
                label: 'Military',
                value: 'military'
            },
            {
                label: 'Not Employed',
                value: 'not_employed'
            },
            {
                label: 'Retired',
                value: 'retired'
            },
            {
                label: 'Self Employed',
                value: 'self_employed'
            }
        ],
        name: 'loan[employment_status]',
        id: 'loan_employment_status',
        register: 'employmentStatus',
        classNames: 'text-input col-11 col-md-5 my-2 float-left',
        top: 62,
        slide: 3,
        answer: null,
        required: true,
        save: true
    },
    {
        question: 'Pay Frequency',
        type: 'select',
        options: [
            {
                label: 'Pay Frequency',
                value: 'select'
            },
            {
                label: 'Once every week',
                value: 'weekly'
            },
            {
                label: 'Once every other week',
                value: 'biweekly'
            },
            {
                label: 'Twice per month',
                value: 'twice_monthly'
            },
            {
                label: 'Once per month',
                value: 'monthly'
            }
        ],
        name: 'loan[pay_frequency]',
        id: 'loan_pay_frequency',
        register: 'payFrequency',
        classNames: 'text-input col-11 col-md-5 my-2 float-left ml-md-3',
        top: 65,
        slide: 3,
        answer: null,
        required: true,
        save: true
    },

    {
        question: 'Annual Individual Income',
        type: 'currency',
        inputMode: 'numeric',
        name: 'loan[annual_income]',
        id: 'loan_annual_income',
        register: 'annualIndividualIncome',
        classNames: 'text-input col-11 col-md-5 my-2 float-left',
        top: 77,
        slide: 4,
        answer: null,
        required: true,
        save: true,
        rules: {
            maxDigits: 7,
            min: 0,
            max: 9999999
        }
    },
    {
        question: 'Do You Rent or Own?',
        type: 'select',
        options: [
            {
                label: 'Do You Rent or Own?',
                value: 'select'
            },
            {
                label: 'Own Outright (No Mortgage)',
                value: 'own_outright'
            },
            {
                label: 'Own with Mortgage',
                value: 'own_with_mortgage'
            },
            {
                label: 'Rent',
                value: 'rent'
            }
        ],
        name: 'loan[housing_status]',
        id: 'loan_housing_status',
        register: 'housingStatus',
        classNames: 'text-input col-11 col-md-5 my-2 float-left ml-md-3',
        top: 80,
        slide: 4,
        answer: null,
        required: true,
        save: true
    },
    {
        question: 'Your Social Security Number?',
        type: 'social',
        inputMode: 'numeric',
        name: 'loan[ssn]',
        id: 'loan_ssn',
        register: 'ssn',
        classNames: 'text-input col-11 col-md-5 my-2 float-left',
        top: 90,
        slide: 4,
        answer: null,
        required: true,
        save: true
    },
    {
        question: 'Please Confirm Your SSN',
        type: 'social',
        inputMode: 'numeric',
        name: 'loan[confirm_ssn]',
        id: 'confirm_ssn',
        register: 'ssn_confirmation',
        classNames: 'text-input col-11 col-md-5 my-2 float-left ml-md-3',
        top: 100,
        slide: 4,
        answer: null,
        required: true,
        save: true,
        rules: {confirm: 'ssn'},
        error: 'The SSN\'s do not match.'
    }
]


export default questions;
